export default __webpack_public_path__ + "static/media/series.6b53abf1.png";